// @flow

class DashboardAction {
    static CHART_ADDED_TO_DASHBOARD = "CHART_ADDED_TO_DASHBOARD";
    static DASHBOARD_RENAMED = "DASHBOARD_RENAMED";
}

export default DashboardAction;